
import Additional from "@core/Additional.js";
import Constant from "@constant/index.js";
import Sku from "@core/Sku.js";

export default class CTOAdditional extends Additional{
    constructor(){
        super();
        this._additionalType = Constant.ADDITIONAL_TYPE.CTO;
    }

    init(data){
        this._data = data;

        this._data.forEach(x => {
            let _sku = new Sku();
            for(let i in x){
                _sku["_"+i] = x[i];
            }
            _sku.setAdditionalParent(this);
            this.addItem(_sku);
        });
    }
}